export default "__VITE_ASSET__D7b3W7jt__"